import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface MijnFNVTipBlockProps {
    text : string;
    icon : string;
    layout : string;
    additionalCssClass : string;
}

export class MijnFNVTipBlock extends React.Component<MijnFNVTipBlockProps> {
    render () {
        let content = ReactHtmlParser(this.props.text);

        if ((this.props.layout || "").toLowerCase() === "callout") {
            return <div className={"row content__callout--widget content__callout content__callout-yellow " + 
                (this.props.additionalCssClass || "")}>
                <div className="col-auto content__callout-icon-container content__callout-tip">
                    <span className={"icon icon-" + this.props.icon}></span>
                </div>
                <div className="col content__callout-content">
                    {content}
                </div>
            </div>;
        }

        if ((this.props.layout || "").toLowerCase() === "text") {
            return <div className={"fnv-form__container-form widget mijn-fnv-form__tip-block " + 
                (this.props.additionalCssClass || "")}>
                <div className="mijn-fnv__warning">
                    <span className={"icon icon-" + this.props.icon}></span>
                    {content}
                </div>
            </div>;
        }

        return null;
    }
}